import { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { NotificationManager } from 'react-notifications';
import Select from 'react-select';
import { selectCustomStyles } from '../../../components/common/shared/select.styled';
import { useAccessToken } from '../../../components/common/hooks/useAccessToken';
import { isAdminSelector } from '../../../components/store/auth/selectors';
import { showLoader, hideLoader } from '../../../components/store/common/slice';
import { changePartnersList } from '../../../components/store/admin/slice';
import { StyledButtonWrapper } from '../RenewReports/RenewReports.styled';
import { StyledDropdownWrapper } from './FailedReports.styled';

const FailedReports = () => {
    const isAdmin = useSelector(isAdminSelector);
    const { t } = useTranslation();
    const client = useAccessToken();
    const dispatch = useDispatch();
    const partnersList = useSelector(state => state.admin.partnersList);

    const [currentPartner, setCurrentPartner] = useState([]);
    const [partnersOptions, setPartnersOptions] = useState([]);
    const [generateBtnDisabled, setGenerateBtnDisabled] = useState(true);

    useEffect(() => {
        if (!client) return;
        (async function () {
            dispatch(showLoader());
            if (partnersList.length > 0) {
                setPartnersOptions(partnersList)
            } else {
                const { partners } = await client.get('/operations/data/partners');
                const optionsArr = (partners ?? []).map(item => ({
                    value: item.partnerID,
                    label: item.partnerName,
                    disabled: item.disabled
                }));
                setPartnersOptions(optionsArr);
                dispatch(changePartnersList(optionsArr));
            }

            dispatch(hideLoader());
        })();
    }, [client]);

    const onPartnerChange = e => setCurrentPartner(e);

    useEffect(() => {
        setGenerateBtnDisabled(false);
    }, [currentPartner]);

    const createPayloadArr = arr => {
        let options = [];
        arr.map(item => options.push(item.value));
        return options
    };

    const onGenerateClick = async () => {
        dispatch(showLoader());
        const partner_ids = createPayloadArr(currentPartner)
        const payload = partner_ids.length > 0 ? { partner_ids } : {};
        const result = await client.post('/operations/failed-report/', payload);
        dispatch(hideLoader());
        if (result) NotificationManager.success(t('adminReports.success'))
        else NotificationManager.error(t('buildings.something_wrong'))
    };

    if (!isAdmin) return <div>{t('searchPayments.noAdminRights')}</div>;

    return (
        <>
            <StyledDropdownWrapper>
                <div className='dropdown'>
                    <label className="label">{t('autoCampaign.actions.labels.partner')}</label>
                    <Select
                        styles={selectCustomStyles}
                        options={partnersOptions}
                        onChange={onPartnerChange}
                        name="partnerName"
                        isMulti
                        isOptionDisabled={option => option.disabled}
                    />
                </div>
            </StyledDropdownWrapper>
            <StyledButtonWrapper>
                <button
                    className='bllink-button'
                    onClick={onGenerateClick}
                    disabled={generateBtnDisabled}
                >
                    {t('adminReports.generateBtn')}
                </button>
            </StyledButtonWrapper>
        </>
    );
};

export default FailedReports;
